import React, { createContext, useContext, useState, useCallback } from 'react';

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [adminToken, setAdminToken] = useState(localStorage.getItem('admin_token'));
  const [adminEmail, setAdminEmail] = useState(localStorage.getItem('admin_email'));

  const adminLogin = useCallback((token, email) => {
    localStorage.setItem('admin_token', token);
    localStorage.setItem('admin_email', email);
    setAdminToken(token);
    setAdminEmail(email);
  }, []);

  const adminLogout = useCallback(() => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_email');
    setAdminToken(null);
    setAdminEmail(null);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ adminToken, adminEmail, adminLogin, adminLogout, isAdmin: !!adminToken }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
